<template>
  <div>
    <Modal
      v-model="openIpBehavior"
      width="800px"
      :footer-hide="true"
      :styles="dragStyles"
      :draggable="true"
      @on-visible-change="visibleChange"
    >
      <p
        slot="header"
        style="color:#19be6b;text-align: center"
      >
        <span>同一{{ loginIp?'ip':'串码' }}</span>
      </p>
      <Table
        :max-height="maxHeight"
        :columns="behaviorColumns"
        :data="behaviorData"
      />
    </Modal>
  </div>
</template>
<script>
import { getSameIpOrDeviceList } from "@/api/package"
import { Loading } from "element-ui"
import sampleDeviceColumns from '@components/assets/SampleDeviceColumns';

export default {
  name: 'SameIpDeviceModal',
  props: {

  },
  data () {
    return {
      behaviorColumns: sampleDeviceColumns(this),
      openIpBehavior: false,
      behaviorData: [],
      loginIp: '',
      deviceId: '',
      userId: '',
      dragStyles: {
        position: 'absolute',
        top: 0,
        left: 0
      },
      maxHeight: window.innerHeight - 300
    }
  },
  methods: {
    openDialog (loginIp, deviceId, userId) {
      this.loginIp = loginIp
      this.deviceId = deviceId
      this.userId = userId
      this.behaviorPageNum = 1
      this.openIpBehavior = true
      this.behaviorTotal = 0
      this.behaviorData = []
      this.getIpBehaviorList()
    },
    getIpBehaviorList () {
      this.loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const _this = this
      const params = {
        userId: this.userId
      }
      if (this.deviceId) {
        params.deviceId = this.deviceId
      }
      if (this.loginIp) {
        params.loginIp = this.loginIp
      }
      this.$post(getSameIpOrDeviceList, params).then(da => {
        _this.behaviorData = da.data || []
        _this.loading.close()
      }).catch(err => {
        _this.loading.close()
        _this.$message.error(err.message)
      })
    },
    visibleChange (visible) {
      if (!visible) {
        this.$emit('close', true)
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>
